import { render, staticRenderFns } from "./ResultShare.vue?vue&type=template&id=f8076d82&scoped=true"
import script from "./ResultShare.vue?vue&type=script&lang=js"
export * from "./ResultShare.vue?vue&type=script&lang=js"
import style0 from "./ResultShare.vue?vue&type=style&index=0&id=f8076d82&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8076d82",
  null
  
)

export default component.exports